import React, { lazy, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useCart } from "../CartContext";
import { useTranslation } from "react-i18next";
import { formatNumber } from "../helper/formatNumber";
import { useRestaurantDetails } from "../context/RestaurantDetailsContext";
import { formatCurrency } from "../helper/formatCurrency";
import { getAppConfig } from "../utilis/appConfig";


//const currency = new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" });
const currency = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
});

function MenuItem(props) {
  const { updateTotalPrice, totalPrice, itemQuantities, updateQuantity } =
    useCart();
  const menuItem = props.MenuItem;
  const cart = props.cart;
  const { restaurantDetails } = useRestaurantDetails();
  const locale = restaurantDetails?.locale || "en-IN";

  const [products, setProducts] = useState([]);
  const [showQSection, setQSection] = useState(false);
  const { id } = useParams();
  const [price, setPrice] = useState(parseFloat(menuItem.price));
  const [showCartButton, setShowCartButton] = useState(true);
  const [inCart, SetinCart] = useState("false");
  const [isDescExpanded, setIsDescExpanded] = useState(false);
  const quantity = itemQuantities[menuItem._id]?.quantity || 0;
  const isAvailable = menuItem.isActive;
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const getLocalizedText = (field) => {
    if (!field) return "";
    if (typeof field === "string") return field;
    if (typeof field === "object")
      return field[i18n.language] || field.en || "";
    return "";
  };
  const { defaultImage } = getAppConfig();
  const isOffer = menuItem.offerDescription;
  // const quantity = itemQuantities[menuItem._id]?.quantity || 0;

  // Add this useEffect to sync showCartButton with quantity
  useEffect(() => {
    setShowCartButton(quantity === 0);
  }, [quantity]);

  /*useEffect(() => {
  fetch('/api/products')
      .then(res => res.json())
      .then(data => setProducts([...data])); // Ensures fresh data
}, []);*/

  // const offerPrice =(menuItem.price - (menuItem.price * menuItem.oldPrice));
  const handleIncreaseMinQuantity = (minquantity, price) => {
    const newQuantity = minquantity == 0 ? 1 : minquantity;
    updateQuantity(menuItem._id, newQuantity, price);
    //updateTotalPrice(menuItem.price);
    setShowCartButton(false);
    props.handleClick(menuItem);
  };

  const handleIncreaseQuantity = () => {
    const newQuantity = quantity + 1;
    updateQuantity(menuItem._id, newQuantity, menuItem.price);
    //updateTotalPrice(menuItem.price);
  };
  const removeItem = (_id) => {
    const removedItem = cart.find((item) => item._id === _id);
    const updatedCart = cart.filter((item) => item._id !== _id);
    props.setCart(updatedCart);
    sessionStorage.setItem("cartValue", JSON.stringify(updatedCart));

    // updateTotalPrice(-removedItem.price);
    setShowCartButton(true);
  };
  const handleDecreaseQuantity = () => {
    if (quantity >= 0) {
      const newQuantity = quantity - 1;
      updateQuantity(menuItem._id, newQuantity, menuItem.price);
      if (newQuantity === 0) {
        removeItem(menuItem._id);
      } else {
        //updateTotalPrice(-menuItem.price);
      }
    }
  };

  const handleAddToCart = () => {
    handleIncreaseQuantity();
    setShowCartButton(false);
  };

  const hasVariants = menuItem.variants?.length > 0;
  const variant = hasVariants ? menuItem.variants[0] : null;

  const basePrice = hasVariants ? variant?.price : menuItem.price;
  const offerPrice = hasVariants ? variant?.offerPrice : menuItem.offerPrice;

  /*useEffect(() => {
  if (!id) return; 
  fetch(`/products-by-subcategory?subcatId=${id}`)
    .then(res => res.json())
    .then(data => {
     
      setProducts(data.products);
    })
    .catch(error => console.error("Error fetching products:", error));
}, [id]);*/
  return (
    <div className="mb-3 px-1.5" style={{ width: "20%", minWidth: "180px" }}>
      <div className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 h-full flex flex-col border border-orange-100/50 hover:border-orange-300 hover:-translate-y-1 group">
        {/* Image Section */}
        <div
          className="relative overflow-hidden"
          style={{ aspectRatio: "4/3" }}
        >
          {/* Veg/Non-Veg Indicator */}
          <div className="absolute top-2 left-2 z-10">
            {/* Veg / NonVeg Indicator */}
            {menuItem.foodType && menuItem.foodType !== "na" && (
              <div
                title={
                  menuItem.foodType === "veg"
                    ? "Vegetarian"
                    : "Non-Vegetarian"
                }
                className="absolute top-2 left-2 z-10"
              >
                <div
                  className="w-6 h-6 rounded bg-white flex items-center justify-center shadow-md"
                  style={{
                    border: `2px solid ${menuItem.foodType === "veg" ? "#22c55e" : "#ef4444"
                      }`,
                  }}
                >
                  <div
                    className="w-2.5 h-2.5 rounded-full"
                    style={{
                      backgroundColor:
                        menuItem.foodType === "veg"
                          ? "#22c55e"
                          : "#ef4444",
                    }}
                  />
                </div>
              </div>
            )}
          </div>

          {/* Badges */}
          {isAvailable === 0 && (
            <div className="absolute inset-0 bg-black/60 flex items-center justify-center z-10">
              <span className="bg-red-500 text-white px-4 py-2 rounded-lg font-bold text-sm">
                SOLD OUT
              </span>
            </div>
          )}
          {isOffer && (
            <div className="absolute top-2 right-2 z-10">
              <span className="bg-gradient-to-r from-orange-500 to-red-500 text-white px-2 py-0.5 rounded-full text-[10px] font-bold shadow-md">
                {isOffer}
              </span>
            </div>
          )}

          <img
            loading="lazy"
            src={
              menuItem.imageUrl
                ? `${process.env.REACT_APP_IMAGE_BASE_URL}${menuItem.imageUrl}`
                : defaultImage
                  ? `${process.env.REACT_APP_IMAGE_BASE_URL}${defaultImage}`
                  : "/img/finglider_logo.jpg"
            }
            onError={(e) => {
              const img = e.currentTarget;
              img.onerror = null;
              img.src = defaultImage
                ? `${process.env.REACT_APP_IMAGE_BASE_URL}${defaultImage}`
                : "/img/finglider_logo.jpg";
            }}
            className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500 ease-out"
            style={{ objectPosition: "center" }}
            alt={getLocalizedText(menuItem.productName)}
          />
        </div>

        {/* Content Section */}
        <div className="p-2 flex flex-col flex-grow">
          {/* Product Name */}
          <h6
            className="text-sm text-gray-900 mb-1 line-clamp-2 leading-tight"
            style={{ fontWeight: 550 }}
          >
            {getLocalizedText(menuItem.productName)}
          </h6>

          {/* Description */}
          {menuItem.description && (
            <div className="text-xs text-gray-600 mb-1.5 flex-grow">
              <p
                className={`${!isDescExpanded ? "line-clamp-2" : ""
                  } leading-snug`}
              >
                {getLocalizedText(menuItem.description)}
              </p>
              {getLocalizedText(menuItem.description).length > 100 && (
                <button
                  onClick={() => setIsDescExpanded(!isDescExpanded)}
                  className="text-orange-600 hover:text-orange-700 font-semibold text-[10px] mt-0.5 transition-colors duration-200"
                >
                  {isDescExpanded ? "Read less" : "Read more"}
                </button>
              )}
            </div>
          )}
          {/* Price Section */}
          {/* Price Section */}
          {offerPrice ? (
            (() => {
              const discount = Math.round(
                ((basePrice - offerPrice) / basePrice) * 100
              );

              return (
                <div className="mb-1.5">
                  <div className="flex items-center space-x-1" dir="ltr">
                    <span className="text-sm font-medium text-gray-800">
                      {formatCurrency(offerPrice, locale)}
                    </span>
                    <span className="text-[10px] text-gray-400 line-through">
                      {formatCurrency(basePrice, locale)}
                    </span>
                    <span className="bg-green-100 text-green-700 text-[9px] font-medium px-1 py-0.5 rounded">
                      {discount}% OFF
                    </span>
                  </div>
                </div>
              );
            })()
          ) : (
            <div className="mb-1.5">
              <span className="text-sm font-medium text-gray-800">
                {formatCurrency(basePrice, locale)}
              </span>
            </div>
          )}


          {/* Quantity Sections */}
          {showQSection &&
            menuItem.quantitySections?.map((offeritem, index1) => (
              <button
                key={index1}
                onClick={() => {
                  handleIncreaseMinQuantity(
                    offeritem.minQuantity,
                    offeritem.price,
                  );
                }}
                className="text-sm text-orange-600 hover:text-orange-700 font-medium mb-2"
              >
                ADD {offeritem.name}
              </button>
            ))}

          {/* Add to Cart Button */}
          {showCartButton ? (
            <button
              onClick={() => {
                props.handleClick(menuItem);
                handleAddToCart();
              }}
              className="w-full py-2 text-sm font-medium bg-gradient-to-r from-orange-500 to-orange-600 text-white border-0 rounded-xl hover:from-orange-600 hover:to-orange-700 active:scale-95 transition-all duration-200 shadow-md hover:shadow-lg"
            >
              {t("add")}
            </button>
          ) : (
            <div className="flex items-center justify-center space-x-2.5">
              <button
                onClick={handleDecreaseQuantity}
                className="flex items-center justify-center w-8 h-8 bg-white border border-gray-200 text-gray-600 rounded-lg hover:bg-gray-50 active:scale-95 transition-all duration-200 shadow-sm"
              >
                <svg
                  className="w-3.5 h-3.5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.5}
                    d="M20 12H4"
                  />
                </svg>
              </button>
              <span className="flex items-center justify-center min-w-[32px] h-8 text-sm font-semibold text-gray-800">
                {formatNumber(quantity, lang)}
              </span>
              <button
                onClick={handleIncreaseQuantity}
                className="flex items-center justify-center w-8 h-8 bg-orange-500 text-white rounded-lg hover:bg-orange-600 active:scale-95 transition-all duration-200 shadow-sm"
              >
                <svg
                  className="w-3.5 h-3.5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.5}
                    d="M12 4v16m8-8H4"
                  />
                </svg>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default MenuItem;
